export function transformStringToMaps(frase: string): string {
  const uri = encodeURIComponent(frase);
  const b = uri.replace(/%20/g, '+');

  return b.replace(/%2C/g, ',');
}
export function transformStringToWhatsapp(frase: string): string {
  return encodeURIComponent(frase);
}
// https://wa.me/?text=Gostaria%20de%20saber%2sobre%20o%20preço%20do%20apartamento
